module.exports = __webpack_public_path__ + "img/lg_ring_r_o_1_0@3x.0e78c412.png";